import React from 'react'
import ContactSection from '../../Components/Contact/ContactSection'

const Contact = () => {
  return (
    <React.Fragment>
      <ContactSection />
    </React.Fragment>
  )
}

export default Contact
